import { theme } from 'lib/theme'
import { Svg, SvgPath, SvgGroup } from 'primitives/Svg'
import { SvgIconProps } from '.'

export const NoImage: React.FC<SvgIconProps> = ({ css }) => (
  <Svg
    width='70'
    height='70'
    viewBox='0 -70 700 700'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    css={css}
  >
    <SvgGroup>
      <SvgPath
        d='m173.94 102.93-73.641-73.641c-6.6992-6.6992-6.6992-17.562 0-24.262 6.6992-6.6992 17.559-6.6992 24.258 0l509.45 509.45c6.6992 6.6992 6.6992 17.559 0 24.262-6.6992 6.6953-17.559 6.6953-24.262 0l-58.418-58.422h-438.9c-28.422 0-51.461-23.039-51.461-51.461v-274.46c0-28.422 23.039-51.461 51.461-51.461zm263.43 263.42c-25.117 27.844-61.484 45.348-101.93 45.348-75.793 0-137.23-61.441-137.23-137.23 0-40.453 17.504-76.816 45.348-101.93l73.172 73.172c-9.3906 6.1211-15.594 16.715-15.594 28.762 0 18.949 15.359 34.309 34.309 34.309 12.043 0 22.637-6.207 28.758-15.598z'
        fillRule='evenodd'
        className='primary fill'
        css={{
          fill: theme.colors.gray800,
          transition: theme.transitions.iconColor,
        }}
      />
      <SvgPath
        d='m472.66 274.46c0 13.473-1.9414 26.492-5.5625 38.797l137.78 137.78c3.2148-6.7188 5.0117-14.242 5.0117-22.188v-274.46c0-28.422-23.039-51.461-51.461-51.461h-73.945l-26.586-69.785c-7.6016-19.953-26.738-33.141-48.09-33.141h-148.76c-21.352 0-40.488 13.188-48.09 33.141l-7.1641 18.812 90.84 90.84c12.301-3.6172 25.32-5.5625 38.797-5.5625 75.789 0 137.23 61.441 137.23 137.23z'
        className='primary fill'
        css={{
          fill: theme.colors.gray800,
          transition: theme.transitions.iconColor,
        }}
      />
    </SvgGroup>
  </Svg>
)
